import {
  INavigateToNextStepOptions,
  ISignupScreenWithIndex,
  SignupScreen,
  UserProfile,
} from 'fitbeat.gym-core';
import { Gym, IEnabledFeatures, IUserExistsCheck } from 'fitbeat.models';
import Product from 'react-native-iaphub/src/models/product'; // todo: need to not import from their internal models
import { IOpenHomeWorkoutRequest } from '../HomeWorkouts';
import * as actionTypes from './actionTypes';
import {
  IAddAvatarFailure,
  IAddAvatarNextPressedFailure,
  IAddAvatarNextPressedRequest,
  IAddAvatarNextPressedSuccess,
  IAddAvatarRequest,
  IAddAvatarScreenMountedFailure,
  IAddAvatarScreenMountedRequest,
  IAddAvatarScreenMountedSuccess,
  IAddAvatarSuccess,
  IAddAvatarUnMounted,
  ISaveAvatarPressFailure,
  ISaveAvatarPressRequest, ISaveAvatarPressSuccess,
} from './app-onboarding/capture-avatar-actions';

type PlaceHolderTypeForNewStateInterface = any;

export type InviteAcceptStatus = 'accept' | 'reject';
export interface ISignupState {
  isLoading: boolean;
  screens: SignupScreen[];
  signupScreenWithIndex: ISignupScreenWithIndex;
  iap: IIAPState;
  userProfile?: UserProfile;
  enabledFeatures?: IEnabledFeatures;
  userProfileFieldsToUpdateAfterOnboarding: Partial<UserProfile>;
  isUpdatingUserProfile: boolean;
  updatingUserProfileError?: string;
  shouldPersistUser: boolean;
  openInstantWorkout: boolean;
  inviteAcceptStatus: InviteAcceptStatus;
  defaultHomePlanId: string;
  stripeHomePlanSummary: IStripeHomePlanSummary;
  captureEmailLoading: boolean;
  preAccountSetPasswordLoading: boolean;
  userExistsCheckData: IUserExistsCheck | undefined;
  captureEmailError: string | undefined;
  preAccountSetPasswordScreenLoading: boolean;
  installAppScreenLoading: boolean;
  continueSignupUserProfile: undefined | UserProfile;
  loadingExistingAvatar: boolean;
  existingAvatar?: string;
  uploadingAvatar: boolean;
  uploadedAvatar?: string;
  uploadingAvatarErrorMessage?: string;
}

export interface ITrackingState {
  view: ITrackingViewState;
  data: ITrackingDataState;
}

interface ITrackingViewState {
  isLoading: boolean;
  isLoadingWorkout: boolean;
  isLoadingHealth: boolean;
  isLoadingNutrition: boolean;
  isLoadingNutritionWeeklyStats: boolean;
  isLoadingWeeklyWorkoutProgress: boolean;
  workoutLoadError: PlaceHolderTypeForNewStateInterface;
  healthLoadError: PlaceHolderTypeForNewStateInterface;
  bodyMetricStatsLoadError: PlaceHolderTypeForNewStateInterface;
  nutritionLoadError: PlaceHolderTypeForNewStateInterface;
  nutritionWeeklyStatsLoadError: PlaceHolderTypeForNewStateInterface;
  weeklyWorkoutProgressError: PlaceHolderTypeForNewStateInterface;
  isInitialScanStatsLoad: boolean;
  error: string; // string
  monthAndYearRange: PlaceHolderTypeForNewStateInterface; // month and year for the past 2 years for dropdown
  selectedMonthAndYear: PlaceHolderTypeForNewStateInterface; // date object or string or something else? (Initial todays month and year?)
  workoutHeaderDateRange: PlaceHolderTypeForNewStateInterface; // string 1 Jan to 9 Jan
  lastScanDate: PlaceHolderTypeForNewStateInterface;
  scanStatDates: PlaceHolderTypeForNewStateInterface;
  selectedScanStatDate: PlaceHolderTypeForNewStateInterface;
  dashboard: {
      workoutDateRange: PlaceHolderTypeForNewStateInterface;
  },
  weeklyWorkoutStatsIsLoading: boolean;
  bodyMetricStatsIsLoading: boolean;
  isLoadingLeaderboards: boolean;
  loadingLeaderboardsError: PlaceHolderTypeForNewStateInterface;
  isLoadingInactiveLeaderboards: boolean;
  loadingInactiveLeaderboardsError: PlaceHolderTypeForNewStateInterface;
  isLeaderboardOptOutModalVisible: boolean;
  isOptingOutOfLeaderboard: boolean;
  isLoadingUserBreakdown: boolean;
}

interface ITrackingDataState {
  stats: PlaceHolderTypeForNewStateInterface;
  scanStats: PlaceHolderTypeForNewStateInterface;
  workoutStats: PlaceHolderTypeForNewStateInterface;
  nutritionStats: PlaceHolderTypeForNewStateInterface;
  weeklyWorkoutProgress: PlaceHolderTypeForNewStateInterface;
  dashboard: {
      stats: PlaceHolderTypeForNewStateInterface;
      scanStats: PlaceHolderTypeForNewStateInterface;
      workoutStats: PlaceHolderTypeForNewStateInterface;
      nutritionStats: PlaceHolderTypeForNewStateInterface;
      nutritionWeeklyStats: PlaceHolderTypeForNewStateInterface;
  },
  weeklyWorkoutStats: PlaceHolderTypeForNewStateInterface;
  hasLastWorkout: boolean;
  lastWorkoutHasMetrics: boolean;
  effortPointGraphYMax: number;
  bodyMetricStats: PlaceHolderTypeForNewStateInterface;
  bodyMetricSet: PlaceHolderTypeForNewStateInterface;
  leaderboards: PlaceHolderTypeForNewStateInterface;
  inactiveLeaderboards: PlaceHolderTypeForNewStateInterface;
  leaderboardToOptOutOf: PlaceHolderTypeForNewStateInterface;
  userBreakdown: PlaceHolderTypeForNewStateInterface;
}

export interface IUserState {
  enabledFeatures: IEnabledFeatures | undefined;
  loadingEnabledFeatures: boolean;
  isInitialDataLoaded: boolean;
  garminIsEnabledForUser: boolean;
}

interface IStripeHomePlanSummary {
  isLoading: boolean;
  error?: string;
  summary?: any;
}

interface IIAPState {
  isLoading: boolean;
  error?: string;
  product?: Product;
  activeProduct?: Product;
}
export interface IAuthState {
  signup: ISignupState;
  initialUserSetup: any;
  user: IUserState;
}
interface ISignupFlowScreenRequestAction {
  type: typeof actionTypes.SIGNUP_FLOW_SCREEN_REQUEST;
}
interface ISignupFlowScreenSuccessAction {
  type: typeof actionTypes.SIGNUP_FLOW_SCREEN_SUCCESS;
  payload: SignupScreen[];
}
interface ISignupFlowScreenFailureAction {
  type: typeof actionTypes.SIGNUP_FLOW_SCREEN_FAILURE;
}

interface IIapProductsRequestAction {
  type: typeof actionTypes.IAP_PRODUCTS_REQUEST;
}

interface IIapProductsSuccessAction {
  type: typeof actionTypes.IAP_PRODUCTS_SUCCESS;
  payload: {
    productSku: string;
    productsForSale: Product[];
    activeProducts: Product[];
  };
}

interface IIapProductsFailureAction {
  type: typeof actionTypes.IAP_PRODUCTS_FAILURE;
  payload: string;
}

interface IUpdatingUserRequestAction {
  type: typeof actionTypes.UPDATE_USER_PROFILE_REQUEST;
}

interface IUpdatingUserSuccessAction {
  type: typeof actionTypes.UPDATE_USER_PROFILE_SUCCESS;
}
interface IUpdatingUserFailureAction {
  type: typeof actionTypes.UPDATE_USER_PROFILE_FAILURE;
  payload: string;
}

interface IIapBuyRequestAction {
  type: typeof actionTypes.IAP_BUY_REQUEST;
}

interface IIapBuySuccessAction {
  type: typeof actionTypes.IAP_BUY_SUCCESS;
}
interface IIapBuyFailureAction {
  type: typeof actionTypes.IAP_BUY_FAILURE;
  payload: string;
}

interface IStripeHomePlanSummaryRequestAction {
  type: typeof actionTypes.STRIPE_HOME_PLAN_SUMMARY_REQUEST;
}

interface IStripeHomePlanSummarySuccessAction {
  type: typeof actionTypes.STRIPE_HOME_PLAN_SUMMARY_SUCCESS;
  payload: any;
}
interface IStripeHomePlanSummaryFailureAction {
  type: typeof actionTypes.STRIPE_HOME_PLAN_SUMMARY_FAILURE;
  payload: string;
}

interface IOnScreenComplete {
  type: typeof actionTypes.ON_SCREEN_COMPLETE;
  payload: boolean;
}

interface ILoadUserRequestAction {
  type: typeof actionTypes.LOAD_USER_REQUEST;
}

interface IGarminAuthorizationAcceptedRequestAction {
  type: typeof actionTypes.GARMIN_ACCEPTED_AUTHORIZATION_REQUEST;
}

interface IGarminAuthorizationAcceptedSuccessAction {
  type: typeof actionTypes.GARMIN_ACCEPTED_AUTHORIZATION_SUCCESS;
  payload: {
    isAuthorized: boolean,
  };
}

interface IGarminAuthorizationAcceptedRequestFailure {
  type: typeof actionTypes.GARMIN_ACCEPTED_AUTHORIZATION_FAILURE;
}

interface ILoadUserSuccessAction {
  type: typeof actionTypes.LOAD_USER_SUCCESS;
  payload: {
    enabledFeatures: IEnabledFeatures;
    userProfile: UserProfile;
  };
}

interface ILoadUserFailureAction {
  type: typeof actionTypes.LOAD_USER_FAILURE;
}

interface ISetIsInitialDataLoaded {
    type: typeof actionTypes.SET_IS_INITIAL_DATA_LOADED;
}

export interface ISignupNextScreenAction {
  type: typeof actionTypes.NEXT_SCREEN_STEP;
  payload: {
    skipRestOfFlow: boolean;
    currentScreen: SignupScreen;
    userProfile: Partial<UserProfile>;
    gym: Gym | null;
    inviteAcceptStatus?: InviteAcceptStatus;
    options?: INavigateToNextStepOptions;
  };
}

export interface ICaptureEmailFormSubmitted {
  type:
    typeof actionTypes.CAPTURE_EMAIL_SUBMIT_REQUEST |
    typeof actionTypes.CAPTURE_EMAIL_SUBMIT_SUCCESS |
    typeof actionTypes.CAPTURE_EMAIL_SUBMIT_FAILURE;
  payload?: {
    userExistsCheck: IUserExistsCheck;
    error?: string;
  };
}

export interface IPreAccountSetPasswordScreenMounted {
  type:
    typeof actionTypes.SET_PASSWORD_SCREEN_MOUNTED_REQUEST |
    typeof actionTypes.SET_PASSWORD_SCREEN_MOUNTED_SUCCESS |
    typeof actionTypes.SET_PASSWORD_SCREEN_MOUNTED_FAILURE;
  payload?: {
    userExistsCheck: IUserExistsCheck;
  };
}

export interface IAppInstallScreenMounted {
  type:
    typeof actionTypes.INSTALL_APP_SCREEN_MOUNTED_REQUEST |
    typeof actionTypes.INSTALL_APP_SCREEN_MOUNTED_FAILURE;
}

interface IAppInstallScreenMountedSuccess {
  type: typeof actionTypes.INSTALL_APP_SCREEN_MOUNTED_SUCCESS;
  payload: {
    userProfile: UserProfile;
  };
}

export interface IPreAccountSetPasswordFormSubmitted {
  type:
    typeof actionTypes.PRE_ACCOUNT_SET_PASSWORD_REQUEST |
    typeof actionTypes.PRE_ACCOUNT_SET_PASSWORD_SUCCESS |
    typeof actionTypes.PRE_ACCOUNT_SET_PASSWORD_FAILURE;
}

export interface IAppOnboardingStarted {
  type: typeof actionTypes.APP_ONBOARDING_STARTED;
  payload: {
    userProfile: UserProfile;
    enabledFeatures: IEnabledFeatures
  };
}

export type SignupActionTypes = ISignupFlowScreenRequestAction |
  ISignupFlowScreenSuccessAction |
  ISignupFlowScreenFailureAction |
  ISignupNextScreenAction |
  IIapProductsRequestAction |
  IIapProductsSuccessAction |
  IIapProductsFailureAction |
  IIapBuyRequestAction |
  IIapBuySuccessAction |
  IIapBuyFailureAction |
  IUpdatingUserRequestAction |
  IUpdatingUserSuccessAction |
  IUpdatingUserFailureAction |
  IOnScreenComplete |
  IOpenHomeWorkoutRequest |
  IStripeHomePlanSummaryRequestAction |
  IStripeHomePlanSummarySuccessAction |
  IStripeHomePlanSummaryFailureAction |
  ICaptureEmailFormSubmitted |
  IPreAccountSetPasswordFormSubmitted |
  IPreAccountSetPasswordScreenMounted |
  IAppOnboardingStarted |
  IAppInstallScreenMounted |
  IAppInstallScreenMountedSuccess |
  IAddAvatarRequest |
  IAddAvatarSuccess |
  IAddAvatarFailure |
  IAddAvatarNextPressedRequest |
  IAddAvatarNextPressedSuccess |
  IAddAvatarNextPressedFailure |
  IAddAvatarScreenMountedRequest |
  IAddAvatarScreenMountedSuccess |
  IAddAvatarScreenMountedFailure |
  ISaveAvatarPressRequest |
  ISaveAvatarPressSuccess |
  ISaveAvatarPressFailure |
  IAddAvatarUnMounted;

export type UserActionTypes =
    ILoadUserRequestAction |
    ILoadUserSuccessAction |
    ILoadUserFailureAction |
    ISetIsInitialDataLoaded |
    IGarminAuthorizationAcceptedRequestAction |
    IGarminAuthorizationAcceptedRequestFailure |
    IGarminAuthorizationAcceptedSuccessAction;

export interface INavigateToNextStep {
  currentScreen: SignupScreen;
  userProfile: Partial<UserProfile>;
  inviteAcceptStatus?: InviteAcceptStatus;
  userServiceClient?: any;
  skipRestOfFlow?: boolean;
  // temp
  getMealData?: any;
  options?: INavigateToNextStepOptions,
}

export enum PaywallPage {
  Workout = 'Workout',
  Nutrition = 'Nutrition',
  Tracking = 'Tracking',
}

export enum PaywallScreen {
  SelectStudioPlan = 'SelectStudioPlan',
  InAppPurchase = 'InAppPurchase',
  CardPayment = 'CardPayment',
}
